import YourBetsControllerImpl from './your-bets-controller.jsx';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const { UIControllerView } = MojitoCore.Presentation;

/**
 * YourBets module.
 *
 * @class YourBetsController
 * @name module
 *
 * @extends Mojito.Core.Presentation.UIControllerView
 * @memberof Mojito.Modules.YourBets
 */

/**
 * `YourBets` module prop types.
 *
 * @property {Function} [onSelectionClick = () => {}] - The callback function triggered when a selection is clicked.
 *
 * @memberof Mojito.Modules.YourBets.module
 */
const propTypes = {
    onSelectionClick: PropTypes.func,
};

const defaultProps = {
    onSelectionClick: noop,
};

export default UIControllerView(
    'YourBetsController',
    YourBetsControllerImpl,
    propTypes,
    defaultProps
);
